import type { IndexCollectionContentType } from '@/lib/blocks/collection/index-collection/registry';
import type { IndexCollectionCardComponentProps } from './index-collection-renderers';
import { INDEX_COLLECTION_RENDERERS_BY_CONTENT_TYPE } from './index-collection-renderers';

export function IndexCollectionCard({
  contentType,
  ...cardProps
}: IndexCollectionCardComponentProps & {
  contentType: IndexCollectionContentType;
}) {
  const CardComponent = INDEX_COLLECTION_RENDERERS_BY_CONTENT_TYPE.get(contentType)?.Card;

  if (!CardComponent) {
    return null;
  }

  return <CardComponent {...cardProps} />;
}
